/**
 * @param {Function} fn 实际执行函数
 * @param {Number} delay 执行延迟，单位毫秒（ms）
 * @param {Boolean} immediate 是否立即执行
 * @return {Function} 返回一个“防反跳”函数
 */
export function debounce<T extends (...args: any) => any>(
  fn: T,
  delay: number,
  immediate?: boolean
): (...args: Parameters<T>) => void {
  // 定时器
  let timer: ReturnType<typeof setTimeout>;

  return function(this: ThisParameterType<T>, ...args) {
    if (timer) {
      clearTimeout(timer);
    }
    if (immediate && !timer) {
      fn.apply(this, args);
      timer = setTimeout(() => {}, delay);
      return;
    }
    timer = setTimeout(() => {
      fn.apply(this, args);
    }, delay);
  };
}

/**
 * @param {Function} fn 实际执行函数
 * @param {number} threshold 执行间隔，单位毫秒（ms）
 * @return {Function} 返回一个“节流”函数
 */
export function throttle<T extends (...args: any) => any>(
  fn: T,
  threshold: number
): (...args: Parameters<T>) => void {
  // 定时器
  let timer: ReturnType<typeof setTimeout>;
  // 记录上次执行的时间
  let last: number;
  // 默认间隔默认为250ms
  threshold || (threshold = 250);

  return function(this: ThisParameterType<T>, ...args) {
    const now = +new Date();

    if (last && now < last + threshold) {
      clearTimeout(timer);

      timer = setTimeout(() => {
        last = now;
        fn.apply(this, args);
      }, threshold);
    } else {
      last = now;
      fn.apply(this, args);
    }
  };
}
